import { http } from "config/http";
import { inherits } from "util";


type bodyType = {
    client_env: string | null,
    generate: boolean | null,
    conversation_id?: string | undefined,
    source_name: string,
    prompt: string,
    settings: object,
    subject?: string,
    email_content?: string,
    user_name: string | null
}
export const generateEmail = async (body: bodyType) => {
    try {
        const res: any = await http.post(`generation`, body)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error?.message }
    }
}

export const emailTitleUpdate = async (conversation_id: any, title: any, source_name: string) => {
    try {
        const res: any = await http.put(`update_generation_title?conversation_id=${conversation_id}&title=${title}&source_name=${source_name}&client_env=${localStorage.getItem("clientName")}`)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error?.message }
    }
}

export const emailHistory = async (source_name: string) => {
    try {
        const res: any = await http.get(`get_generation_userwise_history?client_env=${localStorage.getItem("clientName")}&user_name=${localStorage.getItem("username")}&source_name=${source_name}`)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error?.message }
    }
}

export const emailHistoryById = async (id: string, source_name: string) => {
    try {
        const res: any = await http.get(`get_generation_by_conversation_id?client_env=${localStorage.getItem("clientName")}&conversation_id=${id}&source_name=${source_name}`)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error?.message }
    }
}

export const emailHistoryByVersion = async (id: string | undefined, source_name: string, version: number) => {
    try {
        const res: any = await http.get(`conversation_wise_version_history?client_env=${localStorage.getItem("clientName")}&conversation_id=${id}&source_name=${source_name}&version=${version}`)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error?.message }
    }
}

export const deleteConversationEmail = async (id: string, source_name: string) => {
    try {
        const res: any = await http.delete(`/delete_generation_conversation?client_env=${localStorage.getItem("clientName")}&conversation_id=${id}&source_name=${source_name}`)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

type translation = {
    client_env: string | null,
    source_name: string,
    language: string,
    content: string,
    conversation_id: string,
    prompt: string,
    settings: object,
    user_name: string | null,
    subject: string
}
export const translateLanguage = async (body: translation) => {
    try {
        const res: any = await http.post(`translation`, body)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error?.message }
    }
}

export const sentimentAnalysis = async (body: any) => {
    try {
        const res: any = await http.post(`document_sentiment?client_env=${localStorage.getItem("clientName")}&user_name=${body.user_name}`, {
            file1: body.file1
        }, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
        return { result: res?.data }
    } catch (error: any) {
        return { error: error?.message }
    }
}

export const sentimentAnalysisFilter = async (body: any) => {
    try {
        const res: any = await http.get(`sentiment_filter?client_env=${localStorage.getItem("clientName")}&conversation_id=${body.conversation_id}&message_id=${body.message_id}&reviews_filter=${body.reviews_filter}&sentiment_filter=${body.sentiment_filter}&search=${body.search}`)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error?.message }
    }
}